const expectedConstantArgumentTypes = ['bool', 'number', 'string'];

function decorator(target) {
    Object.defineProperty(target.prototype, 'bindOnce', {
        value: bindOnce
    });
}

function bindOnce(func, ...constantArguments /* this should not change between renders */) {
    if(!this.bindings)
        this.bindings = {};

    let cachedBoundFunc = findFuncInCache(this.bindings, func, constantArguments);
    if(cachedBoundFunc)
        return cachedBoundFunc;

    cachedBoundFunc = createBoundFunc(this, this.bindings, func, constantArguments);
    addFuncToCache(this.bindings, func, constantArguments, cachedBoundFunc);
    return cachedBoundFunc;
}

function findFuncInCache(bindings, func, constantArguments) {
    const foundFuncs = bindings[func];
    if(!foundFuncs) {
        return null;
    }
    return foundFuncs[constantArguments];
}

function addFuncToCache(bindings, func, constantArguments, cachedBoundFunc) {
    if(constantArguments && constantArguments.some(arg => expectedConstantArgumentTypes.indexOf(typeof arg) === -1)) {
        console.warn("Not necessarily a bug, but it seems unusual that this object is used for one of the constant arguments to bindOnce.", constantArguments);
    }

    let funcs = bindings[func];
    if(!funcs)
        bindings[func] = funcs = {};

    funcs[constantArguments] = cachedBoundFunc;
}

function createBoundFunc(caller, bindings, func, constantArguments) {
    const warningHeuristicLength = 50;
    if(Object.keys(bindings).length > warningHeuristicLength) {
        console.warn(`It seems a bit odd that there are more than ${warningHeuristicLength} bindings in bindOnce for this component. Please review this code.`);
    }

    return constantArguments.length ? func.bind.apply(func,[caller].concat(constantArguments)) : func.bind(caller);
}

export default decorator;
